var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSitejabber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1714,
    height: 364,
    viewBox: "0 0 1714 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350.009 255.98L252.428 257.806C249.139 257.806 245.85 259.634 243.657 262.558C233.79 278.273 203.09 322.13 175.679 352.829C169.833 358.311 160.33 356.849 156.31 349.905C155.579 348.443 154.482 346.982 154.482 346.616C148.635 333.093 130.727 254.883 122.686 245.015C112.819 233.32 28.03 212.123 14.8732 207.737C5.37092 204.448 2.8126 192.022 10.122 185.078C31.6848 164.612 66.4045 135.74 91.256 119.294C94.5455 117.466 96.7381 113.811 96.7381 110.156L95.2766 17.3277C95.2766 10.0183 102.586 4.53628 109.529 7.82552C130.361 16.5968 167.639 39.9868 191.029 60.4531C193.588 63.3768 197.608 64.4731 201.263 63.3768C218.075 58.6258 265.219 45.1034 311.269 42.5451C317.483 42.1797 322.598 47.2962 321.868 53.8747C319.675 75.8031 313.462 122.948 303.228 154.014C302.132 157.303 302.497 160.592 305.056 163.515C314.923 176.307 338.314 208.468 358.78 240.629C362.435 247.574 358.049 255.98 350.009 255.98Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.271 141.588C239.271 153.648 229.404 163.881 217.343 163.881C205.283 163.881 195.415 154.014 195.415 141.588C195.415 129.527 205.283 119.294 217.343 119.294C229.404 119.294 239.271 129.527 239.271 141.588ZM350.009 255.98L252.428 257.806C249.139 257.806 245.849 259.634 243.657 262.558C233.79 278.273 203.09 322.13 175.679 352.829C169.833 358.311 160.33 356.849 156.31 349.905C155.579 348.443 154.482 346.982 154.482 346.616C148.635 333.093 130.727 254.883 122.686 245.015C112.819 233.32 28.03 212.123 14.8732 207.737C5.37092 204.448 2.8126 192.022 10.122 185.078C31.6848 164.612 66.4045 135.74 91.256 119.294C94.5455 117.466 96.7381 113.811 96.7381 110.156L95.2766 17.3277C95.2766 10.0183 102.586 4.53628 109.529 7.82552C130.361 16.5968 167.639 39.9868 191.029 60.4531C193.588 63.3768 197.608 64.4731 201.263 63.3768C218.075 58.6258 265.219 45.1034 311.269 42.5451C317.483 42.1797 322.598 47.2962 321.868 53.8747C319.675 75.8031 313.462 122.948 303.228 154.014C302.132 157.303 302.497 160.592 305.056 163.515C314.923 176.307 338.314 208.468 358.78 240.629C362.435 247.574 358.049 255.98 350.009 255.98ZM292.63 75.0721C293.361 72.5136 290.803 69.9552 287.879 70.321C189.202 80.5541 98.9313 152.552 69.6934 178.5C64.9424 182.52 66.4045 190.195 72.2519 192.388C72.2519 192.388 135.112 202.621 150.097 215.413C161.061 224.914 171.66 281.927 171.66 281.927C173.853 287.41 180.797 288.506 184.817 284.486C269.97 197.139 289.34 99.1931 292.63 75.0721Z",
    fill: "url(#paint0_linear_2435_408)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.612 312.625C124.881 309.335 123.784 306.046 122.687 302.391L91.2558 335.65C89.0626 338.208 87.9663 341.498 87.9663 344.788C87.9663 348.442 89.4284 351.732 91.9868 353.925C94.1795 356.117 97.469 357.214 100.758 357.214C104.413 357.214 107.703 355.752 110.261 353.194L131.093 331.264C129.267 326.147 127.439 319.934 125.612 312.625Z",
    fill: "url(#paint1_linear_2435_408)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.434 256.708C105.875 254.88 100.759 253.054 94.911 250.86L16.7006 330.533C14.1423 333.091 13.0459 336.38 13.0459 339.669C13.0459 342.959 14.1423 346.614 16.7006 348.806C19.2589 350.999 22.5481 352.461 25.8374 352.461C29.1266 352.461 32.4158 351.365 35.3396 348.806L112.819 269.864C111.357 264.383 109.895 259.632 108.434 256.708Z",
    fill: "url(#paint2_linear_2435_408)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.898 232.954L11.9486 259.268C9.7556 261.827 8.2937 265.117 8.2937 268.406C8.2937 271.695 9.39012 275.351 11.9486 277.543C14.5069 279.736 17.7962 281.198 21.0856 281.198C24.3749 281.198 28.0299 279.736 30.2227 277.543L66.4056 240.995C56.1719 238.437 45.9386 235.512 37.898 232.954Z",
    fill: "url(#paint3_linear_2435_408)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.612 312.625C124.881 309.335 123.784 306.046 122.687 302.391L91.2558 335.65C89.0626 338.208 87.9663 341.498 87.9663 344.788C87.9663 348.442 89.4284 351.732 91.9868 353.925C94.1795 356.117 97.469 357.214 100.758 357.214C104.413 357.214 107.703 355.752 110.261 353.194L131.093 331.264C129.267 326.147 127.439 319.934 125.612 312.625Z",
    fill: "url(#paint4_linear_2435_408)",
    stroke: "url(#paint5_linear_2435_408)",
    strokeWidth: 11.8061
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.898 232.954L11.9486 259.268C9.7556 261.827 8.2937 265.117 8.2937 268.406C8.2937 271.695 9.39012 275.351 11.9486 277.543C14.5069 279.736 17.7962 281.198 21.0856 281.198C24.3749 281.198 28.0299 279.736 30.2227 277.543L66.4056 240.995C56.1719 238.437 45.9386 235.512 37.898 232.954Z",
    stroke: "url(#paint6_linear_2435_408)",
    strokeWidth: 11.8061
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.434 256.708C105.875 254.88 100.759 253.054 94.911 250.86L16.7006 330.533C14.1423 333.091 13.0459 336.38 13.0459 339.669C13.0459 342.959 14.1423 346.614 16.7006 348.806C19.2589 350.999 22.5481 352.461 25.8374 352.461C29.1266 352.461 32.4158 351.365 35.3396 348.806L112.819 269.864C111.357 264.383 109.895 259.632 108.434 256.708Z",
    stroke: "url(#paint7_linear_2435_408)",
    strokeOpacity: 0.5,
    strokeWidth: 11.8061
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2435_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.009 255.98L252.428 257.806C249.139 257.806 245.85 259.634 243.657 262.558C233.79 278.273 203.09 322.13 175.679 352.829C169.833 358.311 160.33 356.849 156.31 349.905C155.579 348.443 154.482 346.982 154.482 346.616C148.635 333.093 130.727 254.883 122.686 245.015C112.819 233.32 28.03 212.123 14.8732 207.737C5.37092 204.448 2.8126 192.022 10.122 185.078C31.6848 164.612 66.4045 135.74 91.256 119.294C94.5455 117.466 96.7381 113.811 96.7381 110.157L95.2766 17.3277C95.2766 10.0183 102.586 4.53628 109.529 7.82552C130.361 16.5968 167.639 39.9868 191.029 60.4531C193.588 63.3768 197.608 64.4731 201.263 63.3768C218.075 58.6258 265.219 45.1034 311.269 42.5451C317.483 42.1797 322.598 47.2962 321.868 53.8747C319.675 75.8031 313.462 122.948 303.228 154.014C302.132 157.303 302.497 160.592 305.056 163.515C314.924 176.307 338.314 208.468 358.78 240.629C362.435 247.574 358.049 255.98 350.009 255.98Z",
    stroke: "url(#paint8_linear_2435_408)",
    strokeWidth: 11.8061
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M503.752 143.715C493.348 134.061 481.905 131.303 469.074 131.303C452.082 130.959 440.986 136.476 440.986 147.164C441.333 158.197 452.776 162.334 469.768 164.058C494.041 166.127 525.944 171.644 525.598 205.433C525.251 229.913 503.752 246.807 469.421 246.807C447.921 246.807 426.422 241.98 409.083 222.672L423.648 203.364C436.131 216.81 454.51 222.672 470.115 222.672C483.292 222.672 497.857 217.845 498.203 205.778C498.55 194.054 487.106 189.572 467.687 187.504C442.719 185.091 414.284 177.16 413.938 148.198C413.938 119.235 444.106 108.202 468.728 108.202C489.187 108.202 504.792 112.685 519.703 125.786L503.752 143.715Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M583.853 72.69C583.853 95.4458 549.525 95.4458 549.525 72.69C549.525 50.6232 583.853 50.6232 583.853 72.69ZM552.99 110.961V242.67H580.731V110.961H552.99Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M660.493 73.7239V111.651H698.988V135.441H660.149V197.847C660.149 211.639 666.387 219.569 679.22 219.569C684.422 219.569 690.665 217.846 696.21 215.087L704.185 238.532C695.169 242.67 687.195 244.394 677.831 244.394C649.048 245.084 632.75 228.879 632.75 198.192V135.786H607.437V111.996H632.75V76.4821L660.493 73.7239Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M747.531 187.159C749.955 207.157 766.602 220.259 790.532 220.259C804.051 220.259 820.698 215.087 828.673 206.122L846.709 223.362C833.183 238.188 810.294 245.773 789.834 245.773C746.491 245.773 718.749 218.19 718.749 176.47C718.749 136.476 746.834 108.202 788.102 108.202C830.754 108.202 859.537 134.061 854.335 187.504L747.531 187.159ZM827.981 164.058C826.249 143.371 810.991 132.338 788.794 132.338C768.682 132.338 752.036 143.371 747.875 164.058H827.981Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M910.168 110.962V258.186C910.168 291.286 898.031 308.526 868.552 308.526C859.193 308.526 849.829 306.112 840.815 300.251L850.87 278.529C856.415 281.287 862.314 282.666 867.859 282.666C881.036 282.321 883.117 273.357 883.117 258.186V110.962H910.168ZM879.304 72.3451C879.304 95.1018 913.633 95.1018 913.633 72.3451C913.633 49.9341 879.304 49.9341 879.304 72.3451Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.73 111.306H1080.44C1080.44 155.094 1080.44 198.882 1080.44 242.669H1054.08L1052.68 221.293C1044.02 238.188 1023.56 246.118 1007.26 246.118C968.77 246.463 939.644 221.638 939.644 176.815C939.644 133.027 969.81 108.547 1007.96 108.547C1026.68 108.547 1044.71 117.167 1053.04 132.338L1053.73 111.306ZM967.381 176.815C967.381 204.054 986.799 220.604 1010.38 220.604C1067.25 220.604 1067.25 133.717 1010.38 133.717C986.457 133.717 967.381 149.922 967.381 176.815Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.63 56.4849V131.649C1154.29 116.133 1175.79 108.203 1192.09 108.203C1230.24 108.203 1259.02 131.994 1259.02 176.471C1259.02 219.915 1229.89 244.74 1191.4 244.74C1173.71 244.74 1156.03 238.189 1145.63 221.294L1143.89 241.982H1117.88V55.7954L1145.63 56.4849ZM1147.02 176.816C1147.02 202.676 1166.09 219.57 1189.31 219.57C1212.21 219.57 1230.93 203.02 1230.93 176.816C1230.93 149.924 1212.21 134.063 1189.31 134.063C1166.43 134.408 1147.02 151.647 1147.02 176.816Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.89 56.4849V131.649C1324.56 116.133 1346.06 108.203 1362.36 108.203C1400.5 108.203 1429.28 131.994 1429.28 176.471C1429.28 219.915 1400.15 244.74 1361.67 244.74C1343.97 244.74 1326.29 238.189 1315.89 221.294L1314.16 241.982H1288.15V55.7954L1315.89 56.4849ZM1317.27 176.816C1317.27 202.676 1336.34 219.57 1359.59 219.57C1382.47 219.57 1401.19 203.02 1401.19 176.816C1401.19 149.924 1382.47 134.063 1359.59 134.063C1336.7 134.408 1317.27 151.647 1317.27 176.816Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1479.21 187.159C1481.64 207.157 1498.29 220.259 1522.22 220.259C1535.74 220.259 1552.39 215.087 1560.36 206.122L1578.39 223.362C1564.87 238.188 1541.98 245.773 1521.52 245.773C1478.17 245.773 1450.43 218.19 1450.43 176.47C1450.43 136.476 1478.53 108.202 1519.79 108.202C1562.45 108.202 1591.23 134.061 1586.02 187.504L1479.21 187.159ZM1559.66 164.058C1557.93 143.371 1542.68 132.338 1520.48 132.338C1500.37 132.338 1483.73 143.371 1479.57 164.058H1559.66Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1640.12 111.305L1641.85 128.544C1651.55 111.65 1666.47 108.202 1680.69 108.202C1693.52 108.202 1706 112.685 1713.29 119.235L1700.8 143.026C1694.21 137.855 1687.62 135.096 1677.57 135.096C1658.5 135.096 1641.85 146.819 1641.85 170.954V241.98H1614.11V110.616L1640.12 111.305Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2435_408",
    x: -0.000488281,
    y: 0.89917,
    width: 365.955,
    height: 363.538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.36123
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18061
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2435_408"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.18061
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18061
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.441667 0 0 0 0 0.441667 0 0 0 0 0.441667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2435_408",
    result: "effect2_innerShadow_2435_408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2435_408",
    x1: 307.161,
    y1: 51.892,
    x2: 91.7513,
    y2: 267.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1745,
    stopColor: "#52BFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9163,
    stopColor: "#7238DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2435_408",
    x1: 59.745,
    y1: 383.579,
    x2: 144.204,
    y2: 300.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#25E2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19A6D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2435_408",
    x1: -52.9359,
    y1: 416.261,
    x2: 135.48,
    y2: 231.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A443FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A959F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2435_408",
    x1: -22.6394,
    y1: 311.295,
    x2: 70.7483,
    y2: 219.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3958,
    stopColor: "#E55EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8225D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2435_408",
    x1: 59.745,
    y1: 383.579,
    x2: 144.204,
    y2: 300.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#25E2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19A6D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2435_408",
    x1: 87.9663,
    y1: 359.863,
    x2: 120.123,
    y2: 326.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E4FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4FCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2435_408",
    x1: 8.2937,
    y1: 279.878,
    x2: 50.4662,
    y2: 236.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769332,
    stopColor: "#FFF5FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2435_408",
    x1: 17.1141,
    y1: 349.238,
    x2: 107.726,
    y2: 256.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850896,
    stopColor: "#A851F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2435_408",
    x1: 324.074,
    y1: 40.2139,
    x2: 89.7225,
    y2: 286.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00924772,
    stopColor: "#2D9FAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "#2D9FAB",
    stopOpacity: 0.823892
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2D9FAB",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#2D9FAB",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitejabber);
export default __webpack_public_path__ + "static/media/sitejabber.22d15fa8571c860e96511c4b1ddc7d8a.svg";
export { ForwardRef as ReactComponent };